import React from 'react';
import { Hero } from './Hero';
import { PainPoints } from './PainPoints';
import { Bonuses } from './Bonuses';
import { Benefits } from './Benefits';
import { Offer } from './Offer';
import { Guarantee } from './Guarantee';
import { Testimonials } from './Testimonials';
import { FAQ } from './FAQ';
import { FinalCTA } from './FinalCTA';
import { Footer } from './Footer';
import { StickyCTA } from './StickyCTA';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans selection:bg-ocean-teal-light selection:text-ocean-teal-dark" data-id="element-120">
      <main data-id="element-121">
        <Hero data-id="element-122" />
        <PainPoints data-id="element-123" />
        <Bonuses data-id="element-124" />
        <Benefits data-id="element-125" />
        <Offer data-id="element-126" />
        <Guarantee data-id="element-127" />
        <Testimonials data-id="element-128" />
        <FAQ data-id="element-129" />
        <FinalCTA data-id="element-130" />
      </main>
      <Footer data-id="element-131" />
      <StickyCTA data-id="element-132" />
    </div>;
}